import memberProfileModel from './memberProfile';

export interface IApiProspectModal {
  HasDeletedUsers?: boolean;
  Users?: any[];
}

export interface IApiProspectsCount {
  NewViews?: number;
  NewFavourites?: number;
  NewMatches?: number;
}

export class ProspectsModal {
  hasDeletedUsers: boolean;
  users: any[];

  constructor() {
    this.hasDeletedUsers = false;
    this.users = [];
  }

  static mappingObjectProspectModal(data: IApiProspectModal): ProspectsModal {
    const obj = new ProspectsModal();
    obj.hasDeletedUsers = data.HasDeletedUsers || false;
    obj.users = (data.Users && memberProfileModel.mappingObjectsCustomMemberSearch(data.Users)) || [];

    return obj;
  }
}

export default class Prospects {
  profileView: number;
  favourites: number;
  matches: number;

  constructor() {
    this.profileView = 0;
    this.favourites = 0;
    this.matches = 0;
  }

  static mappingObjectCount(data: IApiProspectsCount): Prospects {
    const count = new Prospects();
    count.profileView = data.NewViews || 0;
    count.favourites = data.NewFavourites || 0;
    count.matches = data.NewMatches || 0;
    return count;
  }

  static mappingProspectModal(data: IApiProspectModal): ProspectsModal {
    const obj = ProspectsModal.mappingObjectProspectModal(data);

    return obj;
  }
}
